export interface Streaks {
  currentStreak: number;
  longestStreak: number;
  /** Epoch ms of the last day a game was completed; 0 = never. */
  currentStreakStart: number;
}

export const EMPTY_STREAKS: Streaks = { currentStreak: 0, longestStreak: 0, currentStreakStart: 0 };

/** Local-calendar day key, e.g. "2026-09-29". Streaks follow the player's local midnight. */
export function localDayKey(d: Date): string {
  const p = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

/**
 * Record a completed game. Same local day → unchanged; the day after the last
 * completion → +1; anything else → restarts at 1. Archive games count, since
 * the streak tracks days played, not which game was played.
 */
export function recordCompletion(prev: Streaks, now: Date = new Date()): Streaks {
  const last = new Date(prev.currentStreakStart);
  if (prev.currentStreakStart !== 0 && localDayKey(now) === localDayKey(last)) return prev;
  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);
  const continues = prev.currentStreakStart !== 0 && localDayKey(yesterday) === localDayKey(last);
  const current = continues ? prev.currentStreak + 1 : 1;
  return {
    currentStreak: current,
    longestStreak: Math.max(current, prev.longestStreak),
    currentStreakStart: now.getTime(),
  };
}
